import PropTypes from "prop-types";
import { CheckCompactIcon } from "../Icons.jsx";
import s from "./AddonCard.module.css";
import { Skeleton } from "../../../../themeV2";

export default function AddonCard({
  addon,
  isSelected,
  isDisabled = false,
  isIncluded = false,
  onToggle,
  badge,
  disabledText,
  includedText,
}) {
  const showCheck = isIncluded || isSelected;

  const children = (
    <>
      {showCheck ? (
        <span className={s.check}>
          <CheckCompactIcon className={s.checkIcon} />
        </span>
      ) : addon.icon ? (
        <span className={s.iconSlot}>{addon.icon}</span>
      ) : (
        <span className={s.check} />
      )}
      <span className={s.info}>
        <span className={s.titleRow}>
          <span className={s.title}>{addon.title}</span>
          {badge && (
            <span className={`${s.badge} ${isIncluded ? s.badgeIncluded : ""}`}>
              {badge}
            </span>
          )}
        </span>
        {isIncluded && includedText && (
          <span className={s.includedText}>{includedText}</span>
        )}
        {isDisabled && disabledText && (
          <span className={s.disabledText}>{disabledText}</span>
        )}
        {typeof addon.description === "string" && addon.description && (
          <span className={s.desc}>
            {addon.description}
            {addon.additionalDetails ? ". " : ""}
            {addon.additionalDetails ? (
              <span onClick={(e) => e.stopPropagation()}>
                {addon.additionalDetails}
              </span>
            ) : (
              ""
            )}
          </span>
        )}
      </span>
      <span className={s.price}>
        {addon.price?.value === 0
          ? "FREE"
          : `+${addon.price?.format?.() ?? ""}`}
      </span>
    </>
  );

  const className = `${s.card} ${
    isIncluded ? s.cardIncluded : isSelected ? s.cardSelected : ""
  }`;

  if (isIncluded) {
    return (
      <div
        role="status"
        aria-label={`${addon.title} included with your membership`}
        className={className}
      >
        {children}
      </div>
    );
  }

  return (
    <button
      type="button"
      aria-pressed={isSelected}
      disabled={isDisabled}
      className={className}
      onClick={onToggle}
    >
      {children}
    </button>
  );
}

AddonCard.propTypes = {
  addon: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    additionalDetails: PropTypes.node,
    icon: PropTypes.node,
    price: PropTypes.shape({
      value: PropTypes.number,
      format: PropTypes.func,
    }),
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  isIncluded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  badge: PropTypes.string,
  disabledText: PropTypes.string,
  includedText: PropTypes.string,
};

export function AddonCardSkeleton() {
  return (
    <div className={s.skeleton}>
      <Skeleton
        variant="rect"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          borderRadius: "0.25rem",
          flexShrink: 0,
        }}
      />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
        }}
      >
        <Skeleton variant="text" style={{ width: "60%" }} />
        <Skeleton variant="text" style={{ width: "80%" }} />
      </div>
      <Skeleton variant="text" style={{ width: "3rem", flexShrink: 0 }} />
    </div>
  );
}
